import * as Yup from "yup";

export const cardsScheme = Yup.object().shape({
  tagId: Yup.string().required("Tag Id is required."),
  cardNumber: Yup.string().required("Card Number is required."),
  cardId: Yup.string().required("Card Id is required."),
});
